import React, {useContext} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import {routeConfigs} from "../../navigation/routeConfig";
import {useNavigate} from "react-router-dom";
import {useQueryPharmacyUsers} from "../../queries/pharmacy/hooks/useQueryPharmacyUsers";
import {CircularProgress} from "@mui/material";
import {PharmacyContext} from "../../hooks/pharmacyContext";
import {User} from "./User/User";
import {UserContext} from "../../hooks/userContext";

export const Users:React.FunctionComponent = () => {
  const { id }: any = useContext(UserContext);
  const { pharmacyId }: any = useContext(PharmacyContext);
  const navigate = useNavigate();

  const {loading, data} = useQueryPharmacyUsers({
    variables: {
      where: { Pharmacy: { is: { id: { equals: +pharmacyId } } } },
      orderBy: [ { createdAt: "asc" } ]
    },
    awaitRefetchQueries: true,
  });

  if (loading) {
    return <CircularProgress sx={{position: 'absolute', left: 'calc(150px + 50%)', top: '50%'}} color="inherit" />
  }

  return (
    <>
      <Box sx={{ p: 0, mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography component="h1" variant="h5" sx={{mb: 2}}>
          Users
        </Typography>
        <Button sx={{minWidth: '200px'}} variant='contained' onClick={() => navigate(routeConfigs.addUser.path)}>
          Add user
        </Button>
      </Box>
      <Grid container spacing={2} sx={{mb: 2}}>
        {data.findManyPharmacyUsers.map((user: any, index: number) => (
          <Grid key={index} item xs={12} sm={12} md={6} xl={4}>
            <User
              user={user}
              isOwner={user.User.id === data.findManyPharmacyUsers[0].User.id}
              hasEditAccess={user.User.id === +id}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default Users;